import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import OrderCancelListWrap from '../../views/order/cancel/list/OrderCancelListWrap';
import { orderActions } from '../../store/modules/order';
import {
  ORDER_CANCEL_LIST_FILTER_OPTION_MODEL,
  ORDER_CANCEL_LIST_SEARCH_DATA_MODEL,
  ORDER_CANCEL_LIST_SEARCH_OPTION_MODEL,
  ORDER_CANCEL_LIST_SORT_OPTION_MODEL,
} from '../../store/modules/order/models';
import { LIST_PAGINATION_MODEL } from '../../store/modules/app/models';
import { NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT } from '../../constants/service/common/utilConstants';

class OrderCancelListContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  initiate = () => {
    const { setData } = this.props;

    this.getList({
      searchOption: ORDER_CANCEL_LIST_SEARCH_OPTION_MODEL,
      filterOption: ORDER_CANCEL_LIST_FILTER_OPTION_MODEL,
      sortOption: ORDER_CANCEL_LIST_SORT_OPTION_MODEL,
      pagination: LIST_PAGINATION_MODEL,
    });

    /**
     *  검색 박스 초기화
     */
    setData({
      path: ['orderCancelList', 'searchData'],
      value: ORDER_CANCEL_LIST_SEARCH_DATA_MODEL,
    });
  };

  getList = (data) => {
    const { getOrderCancelList, orderCancelList } = this.props;
    const { searchOption, filterOption, sortOption, pagination } = orderCancelList;

    getOrderCancelList({
      searchOption,
      filterOption,
      sortOption,
      pagination,
      ...data,
    });
  };

  /**
   * 엑셀 다운로드
   */
  getExcelDownload = () => {
    const { getOrderCancelListExcelDownload, pageName, orderCancelList, adminInfo } = this.props;

    if (!orderCancelList || !orderCancelList.list.length) {
      message.error(NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT);
      return;
    }

    getOrderCancelListExcelDownload({
      email: adminInfo.email,
      searchOption: orderCancelList.searchOption,
      filterOption: orderCancelList.filterOption,
      sortOption: orderCancelList.sortOption,
      orderPageName: pageName,
    });
  };

  render() {
    const { setData, orderCancelList, mainProductCategorySelectList } = this.props;

    return (
      <OrderCancelListWrap
        setData={setData}
        orderCancelList={orderCancelList}
        mainProductCategorySelectList={mainProductCategorySelectList}
        getList={this.getList}
        getExcelDownload={this.getExcelDownload}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminInfo: state.app.adminInfo,
    orderCancelList: state.order.orderCancelList,
    mainProductCategorySelectList: state.order.mainProductCategorySelectList,
  };
};

const mapDispatchToProps = {
  setData: orderActions.setData,
  getOrderCancelList: orderActions.getOrderCancelList,
  getOrderCancelListExcelDownload: orderActions.getOrderCancelListExcelDownload,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderCancelListContainer);
